import { createAction, props } from '@ngrx/store';
import { TopbarConfig } from '../interfaces/topbar-config.model';

export const OpenMenu = createAction('[Nav] Open menu');
export const CloseMenu = createAction('[Nav] Close menu');
export const ToggleMenu = createAction('[Nav] Toggle menu');

export const SetTopbarConfig = createAction('[Nav] Set Topbar config', props<{ topbar: TopbarConfig }>());
